import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const pragmaticHandler = (event, callback) => {
  if (event.data?.name === 'gameQuit') {
    callback();
  }
};

const slotagregatorHandler = (event, callback) => {
  const quitEvent = typeof event.data === 'string' ? event.data : event.data?.messageId;

  if (quitEvent === 'exitGame' || quitEvent === 'gameExit') {
    callback();
  }
};

const amigoGamingHandler = (event, callback) => {
  if (event.data === 'exitGame') {
    callback();
  }
};

const mascotGamingHandler = (event, callback) => {
  if (event.data.type === 'agg.exit') {
    callback();
  }
};

const inbetgamesHandler = (event, callback) => {
  if (event.data.type === 'backToHomePage') {
    callback();
  }
};

const handlers = {
  Inbetgames: inbetgamesHandler,
  Mascot: mascotGamingHandler,
  Pragmatic: pragmaticHandler,
  Slotegrator: slotagregatorHandler,
  Slotegrator_AmigoGaming: amigoGamingHandler,
};

export const useCasinoGameBroadcastChannel = ({ backPath, iframeRef, provider }) => {
  const history = useHistory();

  const callback = useCallback(() => {
    history.push(backPath);
  }, [backPath, history]);

  const handleGameQuitMessage = useCallback(
    event => {
      if (handlers[provider]) {
        handlers[provider](event, callback);
      }
    },
    [callback, provider],
  );

  useEffect(() => {
    const handleWindowMessage = event => {
      handleGameQuitMessage(event);
    };

    window.addEventListener('message', handleWindowMessage);

    return () => {
      window.removeEventListener('message', handleWindowMessage);
    };
  }, [handleGameQuitMessage, iframeRef]);
};
